module.exports = __webpack_public_path__ + "img/title-1.7bf31989.jpg";